import "./App.css";
import BSG from "./components/BSG";

function App() {
  // Create a reference to attach to DOM elements
  // const sectionRef1 = useRef(null);
  // const sectionRef2 = useRef(null);

  // useEffect(() => {
  //   // Initialize ScrollMagic controller
  //   const controller = new Controller();

  //   // Create scenes for each section
  //   new Scene({
  //     triggerElement: sectionRef1.current,
  //     duration: 300,
  //   })
  //     .setPin(sectionRef1.current)
  //     .addTo(controller);

  //   new Scene({
  //     triggerElement: sectionRef2.current,
  //     duration: 300,
  //   })
  //     .setPin(sectionRef2.current)
  //     .addTo(controller);

  //   // // Clean up scenes on unmount
  //   // return () => {
  //   //   controller.destroy();
  //   // };
  // }, []);

  return <BSG />;
}

export default App;
